module.exports = __webpack_public_path__ + "static/media/miso.d6cc2a07.jpg";